import { getRuntimeConfig } from "../runtimeConfig/runtime-config";

type QueryValue = string | number | boolean | null | undefined;

/**
 * Build an absolute URL for a backend route, optionally appending query params.
 * Skips params whose value is null/undefined/empty string so callers can pass
 * conditional values without ceremony.
 *
 * @example
 *   apiUrl("ListTradeMatchingFiles", { from, to })
 *   apiUrl("TriggerTradeMatchingRun")
 */
export const apiUrl = (
  path: string,
  params?: Record<string, QueryValue>,
): string => {
  const url = new URL(`${getRuntimeConfig().PUBLIC_API_URL}/${path}`);
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value === null || value === undefined || value === "") {
        continue;
      }
      url.searchParams.set(key, String(value));
    }
  }
  return url.toString();
};
